import React from 'react';
import DynamicAddButton from "../DynamicAddButton";
import {useCartConfig} from "../../../contexts/CartConfigContext";
import AddToNolCoreCartButton from "../ClusteredItems/main/AddToNOLCoreCartButton";

export default function AddSingleItemUi(props) {
  const cartConfig = useCartConfig();

  const {product, flavour} = props;
  if (!product) return null;

  const nolCore = cartConfig?.cartFlavour === "nolcore";
  if (nolCore) {
    return <div className="block relative py-2">
      <AddToNolCoreCartButton className="w-full" product={product} />
    </div>
  }

  // skip displaying sku when we have the dummy button for google
  return (
    <div className="py-4">
      <DynamicAddButton
        className="text-xl w-full"
        product={product} flavour={flavour}/>
    </div>
  );
}


